
import { Card, CardContent } from "./lp2/ui/card.tsx";
import { Button } from "./lp2/ui/button.tsx";
import { blogPosts, isPublished } from "./data/blogPosts";
import { Link } from "react-router-dom";
import Navigation from "./lp2/Navigation";
import Footer from "./lp2/Footer";
import { useSeitenTitel } from "./seitenTitel";

const Blog = () => {
  // Muss zum Titel der vorgerenderten blog.html passen.
  useSeitenTitel("Blog: Wenn die Eltern allein leben | EsGehtMirGut.ch");

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Blog & Ratgeber
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Entdecken Sie hilfreiche Artikel rund um das Leben alleine, Sicherheit im Alltag 
              und wie moderne Technologien zu mehr Wohlbefinden beitragen können.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.filter(isPublished).map((post) => (
              <Card key={post.id} className="hover:shadow-lg transition-shadow">
                {/* Nur rendern, wenn ein Bild hinterlegt ist – ein Artikel
                    kann vor dem Foto erscheinen. */}
                {post.image && (
                  <div className="aspect-video bg-gray-200 rounded-t-lg overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.imageAlt || post.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <CardContent className="p-6">
                  <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {post.title}
                  </h2>
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {post.preview}
                  </p>
                  <Link to={`/blog/${post.slug || post.id}`}>
                    <Button variant="outline" className="w-full">
                      Weiterlesen
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
